import { render } from "./GoBack.vue?vue&type=template&id=51d39fd0&scoped=true"
import script from "./GoBack.vue?vue&type=script&lang=js"
export * from "./GoBack.vue?vue&type=script&lang=js"

import "./GoBack.vue?vue&type=style&index=0&id=51d39fd0&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\HolyHeart\\presi\\studentapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d39fd0"]])

export default __exports__